import { useEffect, useState } from "react";
import { api } from "@/lib/config";

let cached = null;
const subscribers = new Set();

export function useSections() {
  const [sections, setSections] = useState(cached || {});

  useEffect(() => {
    const update = (s) => setSections(s);
    subscribers.add(update);
    if (!cached) {
      api.get("/sections").then(({ data }) => {
        cached = data;
        subscribers.forEach((fn) => fn(data));
      }).catch(() => {});
    }
    return () => subscribers.delete(update);
  }, []);

  return sections;
}

export async function refreshSections() {
  const { data } = await api.get("/sections");
  cached = data;
  subscribers.forEach((fn) => fn(data));
  return data;
}

// Returns true if section is visible (default: true). False only when explicitly turned off.
export const visible = (sections, key) => sections[key] !== false;
